import {FC, useState} from 'react'
import {settings} from '../../constants/global'
import {storeBooking} from "../../lib/booking";

interface Props {
    booking?: Booking,
    setBooking: Function
}

const Manual: FC<Props> = ({ booking, setBooking}) => {

    const [brand, setBrand] = useState(booking.car.brand ? booking.car.brand : '')
    const [model, setModel] = useState(booking.car.model ? booking.car.model : '')
    const [year, setYear] = useState(booking.car.year ? booking.car.year : '')

    const updateField = (e: any) => {
        switch (e.target.name) {
            case 'brand':
                booking.car.brand = e.target.value
                setBrand(e.target.value)
                break;
            case 'model':
                booking.car.model = e.target.value
                setModel(e.target.value)
                break;
            case 'year':
                booking.car.year = e.target.value
                setYear(e.target.value)
                break;
        }
        storeBooking(booking, setBooking)
    }

    return (
        <form name="window-repair" method="post" className="" action="" encType="multipart/form-data">
            <div className="form-content">
                <div className="row">
                    <div className="input-outer">
                        <label htmlFor="insurance_company" className="required">Märke</label>
                        <div className="select-style clean">
                            <select id="brand" name="brand" value={brand} onChange={updateField}>
                                <option value="" disabled>Välj</option>
                                {settings.auth.brands.map((brand:any, i:number) => (
                                    <option key={i}  value={brand}>{brand}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="input-outer">
                        <label htmlFor="model" className="required">Modell</label>
                        <input id="model" type="text" name="model" placeholder="" value={model} onChange={updateField}/>
                    </div>
                    <div className="input-outer">
                        <label htmlFor="year" className="required">Årmodell</label>
                        <input id="year" type="text" name="year" placeholder="" value={year} onChange={updateField}/>
                    </div>
                </div>
            </div>
        </form>
    )
};

export default Manual
